import { Col } from "react-bootstrap";

  const openGitHub = () => {
    window.open('https://github.com/RuptuDas011?tab=repositories&q=&type=&language=&sort=stargazers', '_blank');
  };

export const ProjectCard = ({ title, description, imgUrl }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
    
      
      <img src={imgUrl} 
       alt="GitHub"
       onClick={openGitHub}
       style={{ cursor: 'pointer' }}  />
          <button onClick={openGitHub}style={{ position: 'absolute', top:'70%',left:'40%', background: 'rgba(0, 0, 0, 0.5)', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>Open Project</button>
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>         
      </div>
      
     
    </Col>
    
  )
}

